module.exports = __webpack_public_path__ + "static/media/hot-stone-spa-massage.7ba4311d.webp";